// Browser agent keys are ingest-only — they can send telemetry but never read account data.
// They are embedded in the JS bundle and visible to anyone inspecting browser source by
// design (same as member-app's own values below, which this account/license key matches —
// the account and license key are shared org-wide across Browser apps; only the
// application ID is unique per app, which is why it's what hasPlaceholderCredentials checks
// per-environment rather than a single one-shot check).
export const NR_ACCOUNT_ID = '6533080';
// "iservice-customer" (production), registered 2026-09-09.
export const NR_PROD_APPLICATION_ID = '601675005';
// "iservice-customer-dev" (non-prod), registered 2026-09-09.
export const NR_NON_PROD_APPLICATION_ID = '601675007';
export const NR_LICENSE_KEY = 'NRJS-f4ad22acec70aad32b7';

// Constructing the agent with placeholders would beacon rejected payloads and inject
// distributed-tracing headers into every API call for nothing. Takes the already-resolved
// applicationId (prod or non-prod, whichever the caller selected) — checking only the
// account/license constants would miss a still-placeholder NR_NON_PROD_APPLICATION_ID
// once the other three values are real, letting staging traffic send under a literal
// 'TODO_...' application ID instead of no-op'ing.
export const hasPlaceholderCredentials = (
  licenseKey: string,
  accountId: string,
  applicationId: string,
): boolean =>
  licenseKey.startsWith('TODO_') ||
  accountId.startsWith('TODO_') ||
  applicationId.startsWith('TODO_');
